'use client';
import { useOptions } from '@/lib/api/common/options.queries';
import OptionFilterList from './OptionFilterList';
import SidebarSection from './SidebarSection';

const LocationComponent = () => {
  const { data: locationOptions } = useOptions({
    gkey: 'location',
    withChildren: true,
  });

  return (
    <SidebarSection title="Байршил">
      <OptionFilterList options={locationOptions} paramName="locationIds" />
    </SidebarSection>
  );
};

export default LocationComponent;
